<script>
  import Header from './Header.svelte'
  import NoButton from './NoButton.svelte'
  import Question from './Question.svelte'
  import { sessionStore, responsesStore, syncSessionStores } from '../session-store.js'
  import { onMount, onDestroy } from 'svelte';
  export let exam_session
  export let exam
  export let participant
  export let duration
  export let original
  export let questions
  export let active_question = 0
  export let finish_link
  export let online;

  $: answeredCount = ($sessionStore.responses || []).filter((response) => response.choice !== '').length
  $: totalQuestions = ($sessionStore.responses || []).length

  onMount(() => {
    online = navigator.onLine;
    window.addEventListener('online', () => (online = true), false);
    window.addEventListener('offline', () => (online = false), false);
    sessionStore.set(exam_session)
    responsesStore.set(exam_session.responses)
  });

  onDestroy(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', null);
      window.removeEventListener('offline', null);
    }
  });

  function prev() {
    active_question -= 1
  }

  function next() {
    active_question += 1
  }
</script>

<div class="cbt-quiz">
  <Header
    exam={exam}
    participant={participant}
    original={original}
    finish_link={finish_link}
    duration={duration}
    online={online}
    exam_session_id={exam_session.id}
  />

  <div class="cbt-quiz__layout">
    <aside class="cbt-quiz-sidebar">
      <div class="cbt-quiz-sidebar__head">
        <h2 class="cbt-quiz-sidebar__title">Nomor Soal</h2>
        <p class="cbt-quiz-sidebar__meta">{answeredCount}/{totalQuestions} terjawab</p>
      </div>

      <div class="cbt-quiz-sidebar__grid">
        {#each $responsesStore as response, i}
          <NoButton bind:response={response} index={i} bind:active_question={active_question} />
        {/each}
      </div>

      <div class="cbt-quiz-sidebar__legend">
        <span><i class="cbt-quiz-dot cbt-quiz-dot--current"></i> Aktif</span>
        <span><i class="cbt-quiz-dot cbt-quiz-dot--answered"></i> Terjawab</span>
        <span><i class="cbt-quiz-dot cbt-quiz-dot--marked"></i> Ditandai</span>
        <span><i class="cbt-quiz-dot cbt-quiz-dot--empty"></i> Kosong</span>
      </div>
    </aside>

    <section class="cbt-quiz-content">
      {#each $responsesStore as response, i}
        <Question
          bind:exam_session={$sessionStore}
          bind:active_question={active_question}
          i={i}
          questions={questions}
          bind:response={response}
          online={online}
        />
      {/each}

      <div class="cbt-quiz-nav">
        {#if active_question != 0}
          <button type="button" class="btn cbt-btn cbt-btn--ghost" on:click={prev}>
            ← Sebelumnya
          </button>
        {:else}
          <span></span>
        {/if}

        {#if active_question != $responsesStore.length - 1}
          <button type="button" class="btn cbt-btn cbt-btn--primary" on:click={next}>
            Berikutnya →
          </button>
        {/if}
      </div>
    </section>
  </div>
</div>
